export default __webpack_public_path__ + "static/media/previous-slide.4d177805.svg";